import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';

import { Box } from '@/components/blocks/Box';

interface BannerPath {
  smartphone: string;
  tablet: string;
}

interface Props {
  bannerPath: BannerPath;
  downloadLink?: string;
}

const Content = styled(Box)(({ theme }) =>
  css({
    margin: '0 auto',
    position: 'relative',
    display: 'block',
    marginTop: theme.spaces.l,
    width: '100%',
  })
);

const AppBnrSp = styled('img')(({ theme }) =>
  css({
    display: 'none',
    [`@media ${theme.mediaQueries.sp}`]: {
      display: 'block',
      margin: '0 auto',
      width: '100%',
    },
    borderRadius: theme.radii.m,
  })
);

const AppBnrTb = styled('img')(({ theme }) =>
  css({
    display: 'block',
    margin: '0 auto',
    width: '100%',
    [`@media ${theme.mediaQueries.sp}`]: {
      display: 'none',
    },
    borderRadius: theme.radii.m,
  })
);

export const AppPromotion = React.memo((props: Props) => {
  const downloadLink =
    props.downloadLink || 'https://5cmp.app.link/Bif0juyVrXb';

  return (
    <Content>
      <a target='_blank' rel='noreferrer noopener' href={downloadLink}>
        <AppBnrSp src={props.bannerPath.smartphone} />
        <AppBnrTb src={props.bannerPath.tablet} />
      </a>
    </Content>
  );
});

AppPromotion.displayName = 'AppPromotion';
